import React from 'react';
import { Box } from '@mui/material';
import FormSelectField from '../../../../Components/CustomUIElements/FormSelectField';
import { IfFieldProps } from '../type';

/**
 * IfField component handles the question selection part of the auto tagging condition
 * It displays either "If" or "and" label based on the field index
 * and provides a dropdown to select a question
 */
const IfField: React.FC<IfFieldProps> = ({
  field,
  fieldIndex,
  statusIndex,
  supportedQuestions,
  autoTagCondition,
  handleChangeField
}) => {
  return (
    <>
      <Box component={'h4'} sx={{ marginRight: fieldIndex === 0 ? '31px' : '8px' }}>
        {fieldIndex === 0 ? 'If' : 'and'}
      </Box>
      <FormSelectField
        label="Variable"
        isDisabled={!supportedQuestions}
        defaultValue={field.question.id ? field.question.id.toString() : ''}
        options={supportedQuestions
          .filter(
            (question) =>
              question.id === field.question.id ||
              !autoTagCondition.fields?.map((f: any) => f.question.id).includes(question.id)
          )
          ?.map((question) => ({
            value: question.id.toString(),
            label: question.title
          }))}
        onChange={(value) => handleChangeField(statusIndex, fieldIndex, Number(value), 'q')}
        styles={{ width: '290px' }}
      />
    </>
  );
};

export default IfField;
